module.exports = __webpack_public_path__ + "static/media/js.7e11fb1f.png";